import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { type CampaignDetailsModalStore } from 'widgets/CampaignDetailsModal/store/campaignDetailsModalStore'
import { UiContactsTrigger } from './UiContactsTrigger'

import styles from './styles.module.scss'

export const EnrollContacts = observer(({ store }: { store: CampaignDetailsModalStore }) => {
  return (
    <div className={styles.sendParamsWrapper}>
      <Typography ariaLabel={'Send'} variant={'body-rg-medium'} className={styles.title}>
        Send
      </Typography>
      <div className={styles.grid}>
        <Typography ariaLabel={'Send'} variant={'text-input-field'} className={styles.label}>
          Contacts
        </Typography>
        <UiContactsTrigger
          total={store.enrolledContactsCount}
          skipped={store.skippedCount}
          wrapPlaceholderClassName={styles.wrapPlaceholderClassName}
          onClick={store.viewEnrollment}
        />
      </div>
    </div>
  )
})
